import { FC, useContext } from 'react';

import { CloseIcon, H1 } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './Banner.module.scss';
import { IBannerProps } from './interfaces';

export const Banner: FC<IBannerProps> = ({ setBannerShow }) => {
  const { t } = useContext(LocalizationContext);
  return (
    <div className={s.container}>
      <div className={s.content}>
        <div className={s.left}>
          <H1 className={s.title}>{t('settings.banner.title')}</H1>
          <span className={s.subtitle}>{t('settings.banner.subtitle')}</span>
          <button
            onClick={() => {
              window.open('https://lk.smartshell.gg');
            }}
            className={s.button}
          >
            {t('settings.banner.button')}
          </button>
        </div>
        <div className={s.right}>
          <img src="./settings_banner.png" alt="banner" />
        </div>
        <div
          onClick={() => {
            setBannerShow(false);
          }}
          className={s.close_icon}
        >
          <CloseIcon color="light" size="s" />
        </div>
      </div>
    </div>
  );
};
